import React from 'react'
import {useTranslation} from 'react-i18next'
import {FieldComponent} from 'components/Shared/FieldComponent'
import InputAdornment from '@material-ui/core/InputAdornment'
import ClearIcon from '@material-ui/icons/Clear'
import Button from '@material-ui/core/Button'
import styles from './ExternalCarForm.module.css'

export function ExternalCarForm ({ fieldName, onCarRegistrationNumberCleared }) {
  const { t } = useTranslation()

  return (
    <div className='d-flex flex-column'>
      <FieldComponent
        className={styles.registrationNumberField}
        fieldName={`${fieldName}.carRegistrationNumber`}
        label={t('form.order.carrier.carRegistrationNumber')}
        endAdornmentRenderer={() => (
            <InputAdornment position="end"
                            onClick={onCarRegistrationNumberCleared}>
                <Button className={styles.clearButton}>
                    <ClearIcon color="disabled" fontSize="small"/>
                </Button>
            </InputAdornment>
        )}
      />
      <FieldComponent
        fieldName={`${fieldName}.driverInfo`}
        label={t('form.order.carrier.driver.driverDetails')}
      />
    </div>
  )
}
